// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Calendly = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Calendly = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Calendly = _exports.Calendly = function Calendly(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("g", {
      "clip-path": "url(#clip0_49_14247)"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      d: "M19.3401 17.7113V17.7114C19.3455 18.8435 18.428 19.7611 17.2958 19.7611H2.70823C1.58146 19.7611 0.663904 18.8435 0.663904 17.7167V3.12375C0.663904 1.99699 1.58146 1.07943 2.70823 1.07943H17.2958C18.4225 1.07943 19.3401 1.99699 19.3401 3.12375V17.7113ZM2.70823 2.17227C2.18213 2.17227 1.75675 2.59766 1.75675 3.12375V17.7113C1.75675 18.2374 2.18213 18.6628 2.70823 18.6628H17.2958C17.8219 18.6628 18.2472 18.2374 18.2472 17.7113V3.12375C18.2472 2.59766 17.8219 2.17227 17.2958 2.17227H2.70823Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.0543703"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.18955 3.70493H6.18954L6.18956 3.70553C6.19465 3.93459 6.00611 4.12358 5.77634 4.12358C5.54668 4.12358 5.36312 3.94002 5.36312 3.71036V0.654755C5.36312 0.425102 5.54668 0.241541 5.77634 0.241541C6.00599 0.241541 6.18955 0.425102 6.18955 0.654755V3.70493ZM12.7392 8.27038L12.7398 8.27092C12.8041 8.32604 12.8084 8.42731 12.7491 8.4866L12.7491 8.48654L12.7477 8.48813C12.6926 8.55243 12.5913 8.55677 12.532 8.49747L12.5311 8.49659C11.9824 7.99728 11.2745 7.72289 10.5337 7.72289C8.89305 7.72289 7.55968 9.05626 7.55968 10.6969C7.55968 12.3376 8.89305 13.671 10.5337 13.671C11.2744 13.671 11.9822 13.3967 12.5308 12.8976C12.5962 12.8418 12.6932 12.8472 12.748 12.9061C12.8039 12.9717 12.7983 13.0689 12.739 13.1236L12.739 13.1237C12.1351 13.6844 11.3534 13.9863 10.5337 13.9863C8.72191 13.9863 7.24977 12.5142 7.24977 10.7024C7.24977 8.89055 8.72191 7.41842 10.5337 7.41842C11.3534 7.41842 12.1353 7.72038 12.7392 8.27038ZM14.1874 4.12358C13.9578 4.12358 13.7742 3.94002 13.7742 3.71036V0.654755C13.7742 0.425102 13.9578 0.241541 14.1874 0.241541C14.4171 0.241541 14.6006 0.425102 14.6006 0.654755V3.70493C14.6006 3.93502 14.4166 4.12358 14.1874 4.12358Z",
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": "0.0543703"
    })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
      id: "clip0_49_14247"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "20",
      height: "20",
      fill: "currentColor"
    }))));
  };
});
